<template>
    <div>
        <bora-header ></bora-header>
        <div style="background: white; padding-top:135px" >
            <router-view :key="$route.path"></router-view>
        </div>
        <footer-view></footer-view>
    </div>
</template>

<script>
import BoraHeader from '@components/bora/BoraHeader.vue'
import Footer from '@components/bora/Footer.vue'

export default{
    components:{
        BoraHeader,
        FooterView:Footer,
    }
}
</script>



// WEBPACK FOOTER //
// BoraMain.vue?4e744fc0